import { useEffect, useRef } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { serviceRejectHistory } from "../store/api/Services";
import BihamtaTable from "../../Components/BihamtaTable";
import { useDispatch } from "react-redux";
import { Search } from "react-bootstrap-icons";

const ServiceRejectHistory = () => {
    const dispatch = useDispatch();
    const filterData = useRef({});
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, []);
    function search() {
        filterData.current.Skip = 0;
        if (!filterData.current.Take) {
            filterData.current.Take = 10;
        }
        dispatch(serviceRejectHistory(filterData.current));
    }
    function setSearchFilter(e) {
        filterData.current[e.target.name] = e.target.value;
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "نام تکنسین", colName: "StaffName", showInMobile: true },
        { colTitle: "نام مشتری", colName: "CustomerName", showInMobile: true },
        { colTitle: "تاریخ انصراف", colName: "PRejectDate", showInMobile: true },
        { colTitle: "دلیل انصراف", colName: "RejectDesc" },
        { colTitle: "تاریخ پذیرش", colName: "PFirstContactDate" },
        { colTitle: "نوع پذیرش", colName: "PServiceType" },
        { colTitle: "شماره پذیرش", colName: "InvoiceNumber" },
        { colTitle: "شماره تماس مشتری", colName: "CustomerMobile" },
        { colTitle: "شماره تماس تکنسین", colName: "StaffMobile" }
    ]
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    تاریخچه انصراف تکنسین ها
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <Row>
                        <Col md={3} className="form-group">
                            <label>نام تکنسین: </label>
                            <Form.Control onChange={setSearchFilter} name="StaffName" />
                        </Col>
                        <Col md={3} className="form-group">
                            <label>نام مشتری: </label>
                            <Form.Control onChange={setSearchFilter} name="CustomerName" />
                        </Col>
                        <Col md={3} className="form-group">
                            <label>تعداد در صفحه: </label>
                            <select onChange={setSearchFilter} name="Take" className="form-control" defaultValue={10}>
                                <option value={0}>انتخاب کنید</option>
                                <option value={10}>10 ردیف</option>
                                <option value={20}>20 ردیف</option>
                                <option value={50}>50 ردیف</option>
                                <option value={100}>100 ردیف</option>
                            </select>
                        </Col>
                        <Col className="form-group" style={{display:"flex", alignItems:"flex-end", paddingBottom:"2px"}}>
                            <Button className="group-Btn-large" onClick={search}><Search size={18} />&nbsp; جستجو</Button>
                        </Col>
                    </Row>
                    <BihamtaTable columns={tableCols} filterData={filterData.current} searchMethod={(data) => dispatch(serviceRejectHistory(data))} reducerName="service" objectName="serviceRejectHistory" hasPaging={true} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default ServiceRejectHistory;